export default __webpack_public_path__ + "img/train.e61d28fe.png";